import { tv } from 'tailwind-variants';

const bodyStyles = tv({
    slots: {
        base: `
    iris:font-(family-name:--base-type-font-body)
    iris:font-(--sem-type-weight-body)!
    iris:tracking-(--sem-type-tracking-body)
    iris:text-(--comp-color-content-type-body)
  `,
        leading: "iris:leading-(--sem-type-leading-body)",
    },
    variants: {
        inverse: {
            false: "",
            true: {
                base: "iris:text-(--comp-color-content-type-body-inverse)",
            },
        },
        size: {
            lg: { base: "iris:text-(length:--sem-type-size-body-lg)" },
            md: { base: "iris:text-(length:--sem-type-size-body-md)" },
            sm: { base: "iris:text-(length:--sem-type-size-body-sm)" },
            xs: { base: "iris:text-(length:--sem-type-size-body-xs)" },
            xxs: { base: "iris:text-(length:--sem-type-size-body-xxs)" },
        },
    },
    defaultVariants: {
        inverse: false,
        size: "md",
    },
});

export { bodyStyles };
